// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"b4af8fc6","336":"22957fad","481":"22957fad","790":"22957fad"}[chunkId] + ".chunk.css";
};